import { Component, OnInit } from '@angular/core';
import { VersionService, VersionInfo } from '../../services/version.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-version-info',
  templateUrl: './version-info.component.html',
  styleUrls: ['./version-info.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class VersionInfoComponent implements OnInit {
  clientVersion: VersionInfo | null = null;
  serverVersion: VersionInfo | null = null;
  loading = true;
  error = false;

  constructor(private versionService: VersionService) { }

  ngOnInit(): void {
    this.clientVersion = this.versionService.getClientVersion();
    
    this.versionService.getServerVersion().subscribe({
      next: (data) => {
        this.serverVersion = data;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching server version:', err);
        this.error = true;
        this.loading = false;
      }
    });
  }
}
